import { render, staticRenderFns } from "./collectionType2.vue?vue&type=template&id=7c519c39"
import script from "./collectionType2.vue?vue&type=script&lang=js"
export * from "./collectionType2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/godata/pipelines/eShop-Portal-Web-Release-Prod/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7c519c39')) {
      api.createRecord('7c519c39', component.options)
    } else {
      api.reload('7c519c39', component.options)
    }
    module.hot.accept("./collectionType2.vue?vue&type=template&id=7c519c39", function () {
      api.rerender('7c519c39', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/financialcenter/reconciliation/collectionType2.vue"
export default component.exports